module.exports = __webpack_public_path__ + "static/media/EyeInvisible.8b6f6b66.svg";